import React from 'react';
import styled from 'astroturf/react';
import pluralize from 'pluralize';
import { LikesMenu } from 'js/social/UserListMenu/LikesMenu';
import { NewsType, ResourceType, asEnum } from 'js/social/shared/types';

const Container = styled.div`
  display: flex;
  align-items: center;

  > *:not(:first-child):before {
    content: '•';
    margin: 0 10px;
  }
`;

const Likes = styled.button`
  @import 'stylesheets/design_system/font';
  @include body__small;

  background: transparent;
  border: 0;
  color: $ds-gray-dark;
  display: flex;
  padding: 0;
  cursor: pointer;
`;

const Comments = styled.button`
  @import 'stylesheets/design_system/font';
  @include body__small;

  background: transparent;
  border: 0;
  color: $ds-gray-dark;
  display: flex;
  padding: 0;
  cursor: pointer;

  &:hover span {
    text-decoration: underline;
  }
`;

interface Props {
  newsId: number | string;
  newsType: NewsType;
  numLikes: number;
  liked: boolean;
  numComments: number;
  className?: string;
  toggleCommentSection: () => void;
}

const Stats: React.FunctionComponent<Props> = ({
  newsId,
  newsType,
  numLikes,
  liked,
  numComments,
  className,
  toggleCommentSection,
}) => {
  const likesText = `${numLikes} ${pluralize('like', numLikes)}`;
  const likesSection = numLikes > 0 ? <span>{likesText}</span> : null;
  const commentsSection =
    numComments > 0
      ? `${numComments} ${pluralize('comment', numComments)}`
      : null;

  return (
    <Container className={className}>
      {likesSection && (
        <LikesMenu
          resourceId={newsId}
          resourceType={asEnum(ResourceType, newsType)}
          liked={liked}
        >
          <Likes>{likesSection}</Likes>
        </LikesMenu>
      )}
      {commentsSection && (
        <Comments onClick={toggleCommentSection}>
          <span>{commentsSection}</span>
        </Comments>
      )}
    </Container>
  );
};

export default Stats;
